/**
 * * Модель запроса на получнеие списка тегов очереди задач
 */
export default class GetTagsByProjectsIdRequest  {
	/**
	 * * Номер проекта
	 */
	ProjectsId!: Array<number>;
	/**
	 * * Группировка по названию
	 */
	OrderByName?: boolean = false;
	constructor(obj?: Partial<GetTagsByProjectsIdRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
